import { useColumnResizeAndReorder as useBase } from "@tailormed/common-client/component/ColumnResizeAndReorder/useColumnResizeAndReorder";

const ICON_COLUMN_KEYS = ["star", "edit", "hasConflicts", "actions"];
const NO_TRUNCATION_TOOLTIP_KEYS = ["assignee", "facility"];

const useColumnResizeAndReorder = (viewKey, fixedColumnKeys = []) =>
  useBase(viewKey, fixedColumnKeys, {
    iconColumnKeys: ICON_COLUMN_KEYS,
    noTruncationTooltipKeys: NO_TRUNCATION_TOOLTIP_KEYS
  });

export default useColumnResizeAndReorder;
